import { useEffect, useState } from "react";

import { GqlPlannerVisitStatus } from "~/__generated__";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";

const POLL_INTERVAL_IN_MS = 2000;
const POLL_LIMIT_IN_MS = 30000;
const RECENT_APPROVAL_IN_MS = 10 * 60 * 1000;

type Props = {
    status: GqlPlannerVisitStatus | undefined;
    approvedAt: string | null | undefined;
    summaryText: string | null | undefined;
    startPolling: (pollInterval: number) => void;
    stopPolling: () => void;
};

export function useSummaryBeingGenerated({ status, approvedAt, summaryText, startPolling, stopPolling }: Props): boolean {
    const [gaveUp, setGaveUp] = useState(false);

    const beingGenerated =
        !gaveUp && status === GqlPlannerVisitStatus.Approved && isRecent(approvedAt) && (summaryText ?? "").length === 0;

    useEffect(() => {
        if (!beingGenerated) return;

        startPolling(POLL_INTERVAL_IN_MS);
        const limit = setTimeout(() => setGaveUp(true), POLL_LIMIT_IN_MS);

        return () => {
            clearTimeout(limit);
            stopPolling();
        };
    }, [beingGenerated, startPolling, stopPolling]);

    return beingGenerated;
}

function isRecent(approvedAt: string | null | undefined): boolean {
    if (!approvedAt) return false;

    return Math.abs(Date.now() - parseStringToDate(approvedAt).getTime()) < RECENT_APPROVAL_IN_MS;
}
